module.exports = __webpack_public_path__ + "static/media/star-branco.85fdccc7.webp";